import {
  compose,
} from 'recompose';
import Preloader from './preloader';


const enhance = compose();
export default enhance(Preloader);
